import React, { Component } from "react";
import MenuBar from "./navbar";
import Header from "./header";
import { Navigate } from "react-router-dom";
import { BASE_URL, isTokenValid } from "./utility";

class Operations extends Component {
  navigateTo = (path) => {
    window.location.href = path;
  };

  render() {
    if (!isTokenValid()) {
      return <Navigate to="/auth" replace />;
    }

    const actionCards = [
      {
        title: "Tax Invoice",
        label: "GST billing",
        path: "taxinvoice",
        tone: "cyan",
        code: "TX",
      },
      {
        title: "Pro-forma Invoice",
        label: "Pre-sale billing",
        path: "performainvoice",
        tone: "violet",
        code: "PF",
      },
      {
        title: "Credit Note",
        label: "Adjustments",
        path: "creditnote",
        tone: "gold",
        code: "CN",
      },
      {
        title: "Delivery Challan",
        label: "Dispatch",
        path: "deliverychallan",
        tone: "blue",
        code: "DC",
      },
      {
        title: "Reports",
        label: "Invoice records",
        path: "invoicereports",
        tone: "green",
        code: "RP",
      },
      {
        title: "Upload Images",
        label: "Product gallery",
        path: "uploadimage",
        tone: "pink",
        code: "UP",
      },
      {
        title: "Delete Images",
        label: "Gallery cleanup",
        path: "imageDeletion",
        tone: "red",
        code: "DL",
      },
    ];

    return (
      <div
        className="operations-page"
        style={{
          backgroundImage: `url(${BASE_URL + "download/general/bg"})`,
          minHeight: "100vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <style>{`
          .operations-page {
            color: #f8fafc;
            overflow-x: hidden;
            padding-bottom: clamp(28px, 5vw, 56px);
            position: relative;
          }

          .operations-page::before {
            background:
              linear-gradient(135deg, rgba(2, 6, 23, 0.76), rgba(15, 23, 42, 0.38)),
              radial-gradient(circle at 18% 22%, rgba(34, 211, 238, 0.22), transparent 30%),
              radial-gradient(circle at 84% 16%, rgba(244, 114, 182, 0.18), transparent 28%);
            content: "";
            inset: 0;
            pointer-events: none;
            position: absolute;
          }

          .operations-page > * {
            position: relative;
            z-index: 1;
          }

          .operations-shell {
            box-sizing: border-box;
            margin: 0 auto;
            max-width: 1180px;
            padding: clamp(18px, 4vw, 42px) clamp(12px, 4vw, 28px) 0;
            width: 100%;
          }

          .operations-hero {
            align-items: end;
            display: grid;
            gap: 16px;
            grid-template-columns: minmax(0, 1fr) auto;
            margin-bottom: clamp(18px, 4vw, 30px);
          }

          .operations-kicker {
            align-items: center;
            color: #bae6fd;
            display: inline-flex;
            font-size: 0.76rem;
            font-weight: 800;
            gap: 8px;
            letter-spacing: 0;
            margin-bottom: 8px;
            text-transform: uppercase;
          }

          .operations-kicker::before {
            background: #22d3ee;
            border-radius: 999px;
            box-shadow: 0 0 16px rgba(34, 211, 238, 0.8);
            content: "";
            height: 8px;
            width: 8px;
          }

          .operations-title {
            color: #ffffff;
            font-size: clamp(2rem, 7vw, 4.6rem);
            font-weight: 900;
            letter-spacing: 0;
            line-height: 0.95;
            margin: 0;
            text-shadow: 0 16px 34px rgba(0, 0, 0, 0.32);
          }

          .operations-subtitle {
            color: rgba(226, 232, 240, 0.86);
            font-size: clamp(0.95rem, 2.4vw, 1.08rem);
            line-height: 1.55;
            margin: 12px 0 0;
            max-width: 650px;
          }

          .operations-status {
            backdrop-filter: blur(18px);
            background: rgba(15, 23, 42, 0.55);
            border: 1px solid rgba(148, 163, 184, 0.24);
            border-radius: 8px;
            box-shadow: 0 20px 60px rgba(2, 6, 23, 0.24);
            display: grid;
            gap: 5px;
            min-width: 150px;
            padding: 14px 16px;
            text-align: right;
          }

          .operations-status span {
            color: #94a3b8;
            font-size: 0.72rem;
            font-weight: 800;
            letter-spacing: 0;
            text-transform: uppercase;
          }

          .operations-status strong {
            color: #ffffff;
            font-size: 2rem;
            line-height: 1;
          }

          .operations-grid {
            display: grid;
            gap: clamp(12px, 2vw, 18px);
            grid-template-columns: repeat(12, minmax(0, 1fr));
          }

          .operation-card {
            --card-accent: #22d3ee;
            --card-accent-border: rgba(34, 211, 238, 0.62);
            --card-accent-soft: rgba(34, 211, 238, 0.18);
            align-items: stretch;
            backdrop-filter: blur(22px);
            background:
              linear-gradient(145deg, rgba(255, 255, 255, 0.18), rgba(15, 23, 42, 0.58)),
              rgba(15, 23, 42, 0.46);
            border: 1px solid rgba(255, 255, 255, 0.18);
            border-radius: 8px;
            box-shadow: 0 20px 50px rgba(2, 6, 23, 0.28);
            color: #ffffff;
            cursor: pointer;
            display: grid;
            grid-column: span 4;
            min-height: 168px;
            overflow: hidden;
            padding: 0;
            position: relative;
            text-align: left;
            transition: transform 180ms ease, border-color 180ms ease, box-shadow 180ms ease;
            width: 100%;
          }

          .operation-card:nth-child(1),
          .operation-card:nth-child(2) {
            grid-column: span 6;
            min-height: 190px;
          }

          .operation-card:hover,
          .operation-card:focus-visible {
            border-color: var(--card-accent-border);
            box-shadow: 0 24px 64px rgba(2, 6, 23, 0.36), 0 0 0 1px var(--card-accent-soft);
            outline: none;
            transform: translateY(-4px);
          }

          .operation-card::before {
            background: linear-gradient(90deg, var(--card-accent), transparent);
            content: "";
            height: 3px;
            left: 0;
            position: absolute;
            right: 0;
            top: 0;
          }

          .operation-card::after {
            background:
              linear-gradient(90deg, rgba(255, 255, 255, 0.08) 1px, transparent 1px),
              linear-gradient(rgba(255, 255, 255, 0.07) 1px, transparent 1px);
            background-size: 28px 28px;
            content: "";
            inset: 0;
            opacity: 0.16;
            pointer-events: none;
            position: absolute;
          }

          .operation-card-inner {
            display: grid;
            gap: 14px;
            grid-template-rows: auto 1fr auto;
            min-height: inherit;
            padding: clamp(16px, 2.5vw, 22px);
            position: relative;
            z-index: 1;
          }

          .operation-card-top {
            align-items: center;
            display: flex;
            gap: 12px;
            justify-content: space-between;
          }

          .operation-code {
            align-items: center;
            background: var(--card-accent-soft);
            border: 1px solid var(--card-accent-border);
            border-radius: 8px;
            color: #ffffff;
            display: inline-grid;
            flex: 0 0 auto;
            font-size: 0.8rem;
            font-weight: 900;
            height: 44px;
            letter-spacing: 0;
            place-items: center;
            width: 44px;
          }

          .operation-index {
            color: rgba(226, 232, 240, 0.55);
            font-size: 0.78rem;
            font-weight: 800;
          }

          .operation-copy {
            align-self: end;
          }

          .operation-label {
            color: var(--card-accent);
            display: block;
            font-size: 0.78rem;
            font-weight: 800;
            letter-spacing: 0;
            margin-bottom: 7px;
            text-transform: uppercase;
          }

          .operation-title {
            color: #ffffff;
            font-size: clamp(1.22rem, 2.2vw, 1.62rem);
            font-weight: 900;
            letter-spacing: 0;
            line-height: 1.08;
            margin: 0;
            overflow-wrap: anywhere;
          }

          .operation-action {
            align-items: center;
            background: rgba(255, 255, 255, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.16);
            border-radius: 8px;
            color: #e2e8f0;
            display: flex;
            font-size: 0.9rem;
            font-weight: 800;
            justify-content: space-between;
            min-height: 42px;
            padding: 10px 12px;
          }

          .operation-arrow {
            align-items: center;
            background: var(--card-accent);
            border-radius: 999px;
            color: #020617;
            display: inline-flex;
            flex: 0 0 auto;
            font-size: 1.15rem;
            font-weight: 900;
            height: 28px;
            justify-content: center;
            line-height: 1;
            width: 28px;
          }

          .operation-card[data-tone="violet"] {
            --card-accent: #a78bfa;
            --card-accent-border: rgba(167, 139, 250, 0.62);
            --card-accent-soft: rgba(167, 139, 250, 0.2);
          }

          .operation-card[data-tone="gold"] {
            --card-accent: #facc15;
            --card-accent-border: rgba(250, 204, 21, 0.62);
            --card-accent-soft: rgba(250, 204, 21, 0.18);
          }

          .operation-card[data-tone="blue"] {
            --card-accent: #60a5fa;
            --card-accent-border: rgba(96, 165, 250, 0.62);
            --card-accent-soft: rgba(96, 165, 250, 0.18);
          }

          .operation-card[data-tone="green"] {
            --card-accent: #4ade80;
            --card-accent-border: rgba(74, 222, 128, 0.62);
            --card-accent-soft: rgba(74, 222, 128, 0.18);
          }

          .operation-card[data-tone="pink"] {
            --card-accent: #f472b6;
            --card-accent-border: rgba(244, 114, 182, 0.62);
            --card-accent-soft: rgba(244, 114, 182, 0.18);
          }

          .operation-card[data-tone="red"] {
            --card-accent: #fb7185;
            --card-accent-border: rgba(251, 113, 133, 0.62);
            --card-accent-soft: rgba(251, 113, 133, 0.18);
          }

          @media (max-width: 991px) {
            .operations-hero {
              align-items: stretch;
              grid-template-columns: 1fr;
            }

            .operations-status {
              align-items: center;
              grid-template-columns: 1fr auto;
              min-width: 0;
              text-align: left;
            }

            .operations-grid {
              grid-template-columns: repeat(6, minmax(0, 1fr));
            }

            .operation-card,
            .operation-card:nth-child(1),
            .operation-card:nth-child(2) {
              grid-column: span 3;
              min-height: 166px;
            }
          }

          @media (max-width: 640px) {
            .operations-shell {
              padding-left: 10px;
              padding-right: 10px;
            }

            .operations-subtitle {
              font-size: 0.95rem;
            }

            .operations-grid {
              gap: 10px;
              grid-template-columns: 1fr;
            }

            .operation-card,
            .operation-card:nth-child(1),
            .operation-card:nth-child(2) {
              grid-column: 1;
              min-height: 148px;
            }

            .operation-card {
              border-radius: 8px;
            }

            .operation-card:hover,
            .operation-card:focus-visible {
              transform: none;
            }

            .operation-card-inner {
              gap: 12px;
              padding: 14px;
            }

            .operation-code {
              height: 40px;
              width: 40px;
            }

            .operation-title {
              font-size: 1.25rem;
            }

            .operation-action {
              min-height: 46px;
            }
          }
        `}</style>
        <Header />
        <MenuBar />

        <main className="operations-shell">
          <section className="operations-hero" aria-label="Operations overview">
            <div>
              <h1 className="operations-title">Operations</h1>
            
            </div>
          </section>

          <section className="operations-grid" aria-label="Operation actions">
            {actionCards.map((card, index) => (
              <button
                key={card.path}
                type="button"
                className="operation-card"
                data-tone={card.tone}
                onClick={() => this.navigateTo(card.path)}
                aria-label={`Open ${card.title}`}
              >
                <span className="operation-card-inner">
                  <span className="operation-card-top">
                    <span className="operation-code" aria-hidden="true">
                      {card.code}
                    </span>
                
                  </span>

                  <span className="operation-copy">
                    <span className="operation-label">{card.label}</span>
                    <span className="operation-title">{card.title}</span>
                  </span>

                 
                </span>
              </button>
            ))}
          </section>
        </main>
      </div>
    );
  }
}

export default Operations;
